/* eslint-disable default-case */
import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { validate } from "utils/Validator";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
import { parseAndSetFlag } from "utils/Utils";

const StructureCreate = ({ classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [codeData, setCode] = useState(params.typeId ? params.typeId : "");
  const code = codeData?.replace(/[^a-z0-9_]/gi, "");
  const [codeState, setCodeState] = useState(false);
  const [name, setName] = useState("");
  const [nameState, setNameState] = useState(false);
  const [isBranch, setIsBranch] = useState(false);
  const [isBranchState, setIsBranchState] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const [parnetTypeCode, setParentTypeCode] = useState([]);
  const [parentCode, setParentCode] = useState("");
  const [parentCodeState, setParentCodeState] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const outletData = useOutletContext();
  const structureLengthFlags = parseAndSetFlag(outletData?.structureCodeFlag)
  const error = {
    codeErrorMsg: {
      length: "Branch Code length cannot be more than 10 digit",
      required: "Structure Type Code is required",
    },
    nameErrorMsg: {
      required: "Structure Type Name is required",
    },
  };
  useEffect(() => {
    (async () => {
      if (params.typeId) {
        setCallInProgress(true);
        // Get Data from API
        const structureDetails = await apiHandler({
          url: endpoint.MASTER_STRUCTURE_TYPE_FIND + params.typeId,
          authToken: authToken,
        });
        setCallInProgress(false);
        // Set Data to respective fields
        setCode(structureDetails.data.code);
        setName(structureDetails.data.name);
        setIsBranch(structureDetails.data.branchType);
        setParentCode(structureDetails.data.parentCode);
        setIsBranchState("success");
      }
    })();
    getParentCode();
  }, []);
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (code === "") {
      setCodeState(true);
    } else {
      setCodeState(false);
    }
    if (name === "") {
      setNameState(true);
    } else {
      setNameState(false);
    }
    if (parentCode === "") {
      setParentCodeState(true);
    } else {
      setParentCodeState(false);
    }
    if (code && name ) {
      return true;
    } else {
      return false;
    }
  };

  const getParentCode = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.MASTER_STRUCUTRE_PARNET_CODE_FIND,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else {
      setParentTypeCode(res?.data);
    }
  };
  const editStructureInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.MASTER_STRUCTURE_TYPE_UPDATE,
      method: "PUT",
      authToken: authToken,
      data: {
        code: code?.toUpperCase(),
        name: name,
        branchType: isBranch ? true : false,
        parentCode: parentCode?.toUpperCase(),
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const saveStructureInformation = async () => {
    setCallInProgress(true);
    const bulkData = {
      code: code?.toUpperCase(),
      name: name,
      parentCode: parentCode ? parentCode?.toUpperCase() : "",
      branchType: isBranch ? true : false,
    };
    const res = await apiHandler({
      url: endpoint.MASTER_STRUCTURE_TYPE_ADD,
      method: "POST",
      authToken: authToken,
      data: bulkData,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };

  const handlestructureSubmit = async (event) => {
    if (isValidated()) {
      toastUpdate("", "", false);

      let status = "";
      if (params.typeId) {
        status = await editStructureInformation();
      } else {
        status = await saveStructureInformation();
      }
      if (status === "SUCCESS") {
        const msg = params.typeId
          ? "Structure Type updated successfully!"
          : "Structure Type created successfully!";
          toastUpdate("Success", msg, true);
        setRedirectURL(`/coreservice/structure`);
      }
    }
  };
  const onChangeCheckbox = (e, type) => {
    const value = e.target.checked;
    const errorObj = validate(value, [{ type: "required" }], {
      required: "Option is required",
    });
    switch (type) {
      case "BRANCH":
        setIsBranch(value);
        setIsBranchState(errorObj);
        setIsBranchState(errorObj.length ? "error" : "success");
        break;
    }
  };
  const handlecancelstructure = () => {
    navigate("/coreservice/structure");
  };
  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SubHeader
            label={
              params.typeId
                ? "Edit Structure Office"
                : "Create Structure Office"
            }
            button1=" Save"
            button2=" Cancel"
            button1click={handlestructureSubmit}
            button2click={handlecancelstructure}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Structure Office Code"
              required
              error={codeState}
              id="lp_branch_code"
              type="code"
              value={code.toUpperCase() || ""}
              setState={setCode}
              maxLength={structureLengthFlags ? "5" : "3"}
              setError={setCodeState}
              disabled={params.typeId?true:false}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Structure Office Name"
              required
              error={nameState}
              id="lp_branch_name"
              value={name || ""}
              setState={setName}
              setError={setNameState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            {params.typeId ? (
              <CustomeTextField
                label="Parent Code"
                required
                id="lp_branch_parent_code"
                disabled
                value={parentCode?.toUpperCase() || ""}
              />
            ) : (
              <CustomSelectNew
                label="Parent Code*"
                error={parentCodeState}
                value={parentCode}
                setState={setParentCode}
                id="lp_branch_parent_code"
                data={parnetTypeCode}
                type="parentcode"
                setError={setParentCodeState}
              />
            )}
            <p style={{ fontWeight: "bold" }}>
              {" "}
              <input
                id="selectAll"
                type="checkbox"
                checked={isBranch}
                className={classes.checkboxInput}
                onChange={(e) => onChangeCheckbox(e, "BRANCH")}
              />{" "}
              Is this a Branch?
            </p>
          </Grid>
        </Grid>
      </Grid>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
};

export default StructureCreate;
